<template>
    <v-menu
        ref="menu1"
        v-model="startTimeMenu"
        :close-on-content-click="false"
        :nudge-right="20"
        :return-value.sync="startTime"
        lazy
        :disabled="disabled"
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px">
            <template v-slot:activator="{ on }">
            <v-text-field
                :value="typedTime"
                :label="label"
                append-icon="access_time"
                :readonly="disabled"
                outline
                :error="!validTimes"
                :error-messages="errorMsgs"
                :rules="requiredRule"
                :clearable="clearable && !disabled"
                @click:clear="clear"
                @blur="validateAndSyncTime"
                @keyup.enter="validateAndSyncTime"
                @input="onInput"
                v-on="on"
                maxlength="5"
            ></v-text-field>
            </template>
            <v-time-picker
                v-if="startTimeMenu"
                v-model="startTime"
                full-width
            >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="startTimeMenu = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.menu1.save(startTime)">OK</v-btn>
            </v-time-picker>
        </v-menu>
</template>
<script>
export default {
    props: {
        value: {
            required: true
        },
        label: {
            type: String,
            default: "Time"
        },
        clearable: {
            type: Boolean,
            default: true
        },
        required: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
    },
    data(){
        return {
            startTimeMenu: false,
            errorMsgs: [],
            requiredRule: [v => (!!v || !this.required) || 'Required'],
            validTimes: true,
            typedTime: this.value,
        }
    },
    computed: {
        startTime: {
            get(){
                return this.value;
            },
            set(val){
                this.typedTime = val;
                this.$emit('input', val);
            }
        }
    },
    watch: {
    // Sync typed input with startTime when changed programmatically
        value(newVal) {
            this.typedTime = newVal;
        },
    },
    methods: {
        clear(){
            this.$emit('input', "");
            this.typedTime = '';
            this.validTimes = true;
            this.errorMsgs = [];
        },
        onInput(value) {
        // Remove non-digit characters and limit length to 4 (HHmm)
            const sanitized = value.replace(/[^0-9]/g, "").slice(0, 4);

            if (sanitized.length <= 2) {
                this.typedTime = sanitized;
            } else {
                const hours = sanitized.slice(0, 2);
                const minutes = sanitized.slice(2, 4);
                this.typedTime = `${hours}:${minutes}`;
            }

            this.$emit("input", this.typedTime);
        },
        validateAndSyncTime() {
            const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/; // HH:mm format
            if (timeRegex.test(this.typedTime)) {
                this.startTime = this.typedTime; // Update startTime on valid input
                this.validTimes = true;
                this.errorMsgs = [];
                if (this.startTimeMenu) {
                    this.$refs.menu1.save(this.startTime); // Save and close the menu
                }
            } else {
                this.validTimes = false;
                this.errorMsgs = ["Invalid time format"];
            }
        },
    }
}
</script>